// extracted by mini-css-extract-plugin
export default {"innerBody":"PageSettings_innerBody__n0glM","tab":"PageSettings_tab__a-3eF"};